import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, CreditCard, MessageCircle, Banknote, Sparkles } from 'lucide-react';
import { Button } from './ui/Button';
const inicioFeatures = ['Más de 200 páginas', '8 módulos completos', '5 BONUS incluidos', 'Recursos editables', 'Acceso inmediato'];
const premiumFeatures = ['Inicio en la Psicopedagogía Clínica', 'KIT PROFESIONAL PPI', 'Actividades para la práctica psicopedagógica', 'Planillas útiles para Psicope', 'Frases profesionales', 'Agenda Psico', 'Megapack Inclusión Educativa (Premium · $19.990)', 'Psicope en Casa (Premium · $19.990)'];
export function PricingSection() {
  return <section id="oferta" className="py-20 bg-gradient-to-b from-white to-pink-50/40 scroll-mt-8" data-id="element-150">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-151">
        <div className="text-center mb-12" data-id="element-152">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy-900 uppercase tracking-tight mb-3" data-id="element-153">
            Elegí cómo querés acceder
          </h2>
          <p className="text-lg text-slate-600" data-id="element-154">
            Accedé ahora al sistema completo para empezar clínica con más
            claridad.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto items-start" data-id="element-155">
          {/* Plan 1 — Inicio */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl shadow-lg border border-slate-200 overflow-hidden flex flex-col" data-id="element-156">
            <div className="bg-slate-100 text-slate-700 text-center py-3 font-bold text-xs tracking-widest uppercase" data-id="element-157">
              🌸 Plan Inicio
            </div>
            <div className="p-8 flex flex-col flex-grow" data-id="element-158">
              <h3 className="font-serif text-xl font-bold text-navy-900 mb-1 uppercase tracking-tight" data-id="element-159">
                Inicio en la Psicopedagogía Clínica
              </h3>
              <p className="text-slate-600 text-sm mb-6" data-id="element-160">
                Ebook principal + 5 BONUS
              </p>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-161">
                {inicioFeatures.map((f, i) => <li key={i} className="flex items-start gap-3 text-sm" data-id="element-162">
                    <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-163" />
                    <span className="text-slate-700 font-medium" data-id="element-164">{f}</span>
                  </li>)}
              </ul>

              <div className="mb-6 text-center" data-id="element-165">
                <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-166">
                  <span className="text-xs font-bold text-slate-500" data-id="element-167">ARS</span>
                  <span className="text-4xl font-bold text-navy-900 tracking-tighter" data-id="element-168">
                    $19.990
                  </span>
                </div>
                <span className="inline-block text-xs font-semibold text-slate-600 bg-slate-100 px-3 py-1 rounded-full" data-id="element-169">
                  Pago único · Acceso de por vida
                </span>
              </div>

              <Button size="lg" className="w-full" onClick={() => {}} data-id="element-170">
                👉 LO QUIERO
              </Button>
            </div>
          </motion.div>

          {/* Plan 2 — Pack Premium */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="relative bg-white rounded-3xl shadow-2xl border-2 border-pink-500 overflow-hidden flex flex-col" data-id="element-171">
            {/* Floating badge */}
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10" data-id="element-172">
              <span className="inline-flex items-center gap-1 bg-gradient-to-r from-pink-600 to-rose-500 text-white text-xs font-bold px-4 py-1.5 rounded-full shadow-lg whitespace-nowrap" data-id="element-173">
                <Sparkles className="w-3.5 h-3.5" data-id="element-174" /> MÁS ELEGIDO · MEJOR PRECIO
              </span>
            </div>

            <div className="bg-pink-600 text-white text-center py-3 font-bold text-xs tracking-widest uppercase" data-id="element-175">
              ⭐ Pack Premium · Todo Incluido
            </div>

            <div className="p-8 flex flex-col flex-grow" data-id="element-176">
              <h3 className="font-serif text-xl font-bold text-navy-900 mb-1 uppercase tracking-tight" data-id="element-177">
                Pack Premium Psicopedagogía Clínica
              </h3>
              <p className="text-slate-600 text-sm mb-6" data-id="element-178">
                TODO incluido: Ebook + 5 Bonus + 2 Bonus Premium
              </p>

              <ul className="space-y-2.5 mb-6 flex-grow" data-id="element-179">
                {premiumFeatures.map((f, i) => <li key={i} className="flex items-start gap-3 text-sm" data-id="element-180">
                    <CheckCircle2 className="w-5 h-5 text-pink-600 shrink-0 mt-0.5" data-id="element-181" />
                    <span className="text-slate-700 font-medium" data-id="element-182">{f}</span>
                  </li>)}
              </ul>

              <div className="mb-6 text-center bg-pink-50/60 rounded-2xl py-5 px-4 border border-pink-100" data-id="element-183">
                <div className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1" data-id="element-184">
                  Valor real del pack
                </div>
                <span className="text-slate-400 line-through text-base font-medium block mb-1" data-id="element-185">
                  ARS $59.970
                </span>
                <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-186">
                  <span className="text-xs font-bold text-pink-600" data-id="element-187">ARS</span>
                  <span className="text-5xl font-bold text-pink-600 tracking-tighter" data-id="element-188">
                    $29.990
                  </span>
                </div>
                <span className="inline-block text-xs font-bold text-white bg-gradient-to-r from-rose-500 to-pink-600 px-4 py-1.5 rounded-full shadow-sm mb-2" data-id="element-189">
                  🔥 ¡Ahorrás $29.980!
                </span>
                <p className="text-xs font-semibold text-pink-700" data-id="element-190">
                  Pago único · Acceso de por vida
                </p>
              </div>

              <Button size="lg" className="w-full" onClick={() => {}} data-id="element-191">
                👉 LO QUIERO TODO
              </Button>
            </div>
          </motion.div>
        </div>

        {/* Payment methods */}
        <div className="mt-12 text-center" data-id="element-192">
          <div className="flex flex-wrap justify-center items-center gap-3 mb-6" data-id="element-193">
            <span className="inline-flex items-center gap-2 bg-white border border-slate-200 px-4 py-2 rounded-full text-sm font-semibold text-slate-700 shadow-sm" data-id="element-194">
              <CreditCard className="w-4 h-4 text-pink-600" data-id="element-195" /> Tarjeta · Mercado
              Pago
            </span>
            <button className="inline-flex items-center gap-2 bg-white border border-slate-200 px-4 py-2 rounded-full text-sm font-semibold text-slate-700 shadow-sm hover:border-green-400 transition-colors" data-id="element-196">
              <MessageCircle className="w-4 h-4 text-green-600" data-id="element-197" /> Compra por
              WhatsApp
            </button>
            <button className="inline-flex items-center gap-2 bg-white border border-slate-200 px-4 py-2 rounded-full text-sm font-semibold text-slate-700 shadow-sm hover:border-pink-400 transition-colors" data-id="element-198">
              <Banknote className="w-4 h-4 text-pink-600" data-id="element-199" /> Compra por
              Transferencia
            </button>
          </div>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs font-medium text-slate-500" data-id="element-200">
            <span data-id="element-201">✔ Acceso inmediato</span>
            <span data-id="element-202">✔ Descarga digital</span>
            <span data-id="element-203">✔ Acceso de por vida</span>
            <span data-id="element-204">✔ Material listo para usar</span>
          </div>
        </div>
      </div>
    </section>;
}